export const SET_ACTIVE_SORT = (state, sort) => {
  state.activeSort = sort;
};

export const CHANGE_ACTIVE_FILTER = (state, filter) => {
  state.activeFilter = filter;
};

export const SET_SEARCH_QUERY = (state, q) => {
  state.searchQuery = q;
};